// src/components/PeoplePlan/TheBench/utils/workflowConstants.js

// Workflow statuses
export const WORKFLOW_STATUSES = ["New", "In Progress", "Completed", "Rejected"];

// Workflow icon mapping using emojis
export const WORKFLOW_ICONS = {
  "Exiting Employee": "🚪",
  "Future Promotion": "📈",
  "Promote Now": "⭐",
  "Skill Plan": "📚",
  "Store Transfer": "🔄",
  "Exit": "🚪",
  "Developing": "📈",
  "Promote": "⭐",
  "Improvement Plan": "📚",
  "Transfer": "🔄"
};

// Status colors for visual indicators
export const STATUS_COLORS = {
  "New": "#6495ED",        // Blue
  "In Progress": "#FFA500", // Orange
  "Completed": "#32CD32",   // Green
  "Rejected": "#DC3545"     // Red
};

// Default filter values
export const DEFAULT_FILTERS = {
  selectedStatuses: ["New", "In Progress"],
  kanbanFilters: {
    employee_name: "all",
    mum_name: "all",
    workflow_name: "all",
    corp: "all"
  }
};

// Sort options
export const SORT_OPTIONS = {
  employee_name: "Employee Name",
  mum_name: "MUM Name",
  workflow_name: "Workflow Name",
  status: "Status",
  corp: "Location"
};

// View modes
export const VIEW_MODES = {
  TABLE: "table",
  KANBAN: "kanban"
};

// API endpoints
export const API_ENDPOINTS = {
  THE_BENCH_TABLE: "/api/the-bench-table",
  WORKFLOWS_UPDATE: "/api/workflows/update",
  USERS_ME: "/api/users/me"
};